/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSubset } from '../../factoriesAny.js';
export var subsetDependencies = {
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createSubset: createSubset
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSubset.generated.js
// module id = 59
// module chunks = 0